import {
  getPreferencesForTimeline,
  getPreferenceDetails,
  setNewPreference
} from "api/preference";
// import { useSnackbar } from 'notistack';
import { useMutation } from "react-query";

function useTimelinePreferences() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getPreferencesForTimeline, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: "error" }),
    onSuccess: () =>
      console.log("preferences received!", { variant: "success" }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function usePreferenceDetails() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getPreferenceDetails, {
    onError: (err) => console.log(err.message, { variant: "error" }),
    onSuccess: () =>
      console.log("preference details has been received!", {
        variant: "success",
      }),
  });
}

function useSubmitPreferences() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(setNewPreference, {
    onError: (err) => console.log(err.message, { variant: "error" }),
    onSuccess: () =>
      console.log("preference has been submitted!", { variant: "success" }),
  });
}



export { useTimelinePreferences, usePreferenceDetails, useSubmitPreferences };
